import React from 'react';

import { useQuery } from '@apollo/client/react';
import { Box, Loader } from '@opendoor/bricks/core';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';

import {
  ISearchReferrals,
  ISearchReferralsVariables,
  SEARCH_REFERRALS,
} from '../graphql/queries/SearchReferrals';
import { CustomerCardData, getCustomerCardData } from '../helpers/customerCardData';
import { ContentWrapper } from './ContentWrapper';
import CustomerCard from './CustomerCard';
import LadyAtDeskIcon from './icons/LadyAtDeskIcon';

const MAX_SELLER_LEAD_DOCUMENTS = 1000;

const CustomersSection: React.FC = () => {
  const { data, loading } = useQuery<ISearchReferrals, ISearchReferralsVariables>(
    SEARCH_REFERRALS,
    {
      variables: {
        input: {
          size: MAX_SELLER_LEAD_DOCUMENTS,
        },
      },
    },
  );

  const customerCardDataArray = data?.searchReferrals.referrals
    .map((referral) => {
      return getCustomerCardData(referral);
    })
    .filter((data): data is CustomerCardData => {
      return data !== null && !data.hidden;
    });

  let content: JSX.Element;

  if (loading) {
    content = <Loader />;
  } else if (customerCardDataArray?.length) {
    content = (
      <>
        {customerCardDataArray.map((cardData, idx) => (
          <ContentCard forceBorder={idx !== customerCardDataArray.length - 1} key={idx} px={0}>
            <CustomerCard data={cardData} />
          </ContentCard>
        ))}
      </>
    );
  } else {
    content = (
      <>
        <div style={{ height: '30px' }} />
        <Box textAlign="center" mt={9}>
          <LadyAtDeskIcon />
        </Box>
        <Box color="neutrals100" fontSize="s3" textAlign="center" fontWeight="semibold" my={3}>
          No active customers
        </Box>
        <Box width="80%" margin="auto" fontSize="s1" textAlign="center" mb={9}>
          Customers who request an offer from Opendoor using your referral link will appear here so
          that you can support them through the process.
        </Box>
        <div style={{ height: '150px' }} />
      </>
    );
  }

  return (
    <ContentWrapper>
      <ContentCard title="Your Opendoor Customers" borderRadius="roundedSquare">
        {content}
      </ContentCard>
    </ContentWrapper>
  );
};

export default CustomersSection;
